import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";


export default function PerfilGasesSalidaHESP() {
  const [flujosSolidosSHESP, setFlujosSolidosSHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [caudalGasSHESP, setCaudalGasSHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeN2SHESP, setPorcentajeN2SHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentaje02SHESP, setPorcentaje02SHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeH20SHESP, setPorcentajeH20SHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS2SHESP, setPorcentajeS2SHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeS02SHESP, setPorcentajeS02SHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs2S3SHESP, setPorcentajeAs2S3SHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [porcentajeAs4O6SHESP, setPorcentajeAs4O6SHESP] = useState({
    value: [],
    fecha: [],
    estado: [],
  });


  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 36,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateFlujosSolidosSHESP(data);
    populateCaudalGasSHESP(data);
    populatePorcentajen2SHESP(data);
    populatePorcentaje02SHESP(data);
    populatePorcentajeH20SHESP(data);
    populatePorcentajeS2SHESP(data);
    populatePorcentajeS02SHESP(data);
    populatePorcentajeAs2S3SHESP(data);
    populatePorcentajeAs4O6SHESP(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateFlujosSolidosSHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Flujo de Sólidos Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setFlujosSolidosSHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalGasSHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "Caudal de Gas Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCaudalGasSHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajen2SHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%N2 Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeN2SHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentaje02SHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%O2 Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentaje02SHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeH20SHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%H2O Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeH20SHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS2SHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%S2 Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS2SHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeS02SHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%SO2 Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeS02SHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs2S3SHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As2S3 Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs2S3SHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePorcentajeAs4O6SHESP(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%As4O6 Salida HESP"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setPorcentajeAs4O6SHESP({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil de Gases Salida HESP"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- Flujo de Sólidos Salida HESP --------------------------------------- */}
            <Chart.Line
              name="Flujo de Sólidos Salida HESP"
              data={flujosSolidosSHESP.value}
              yAxis={0}
            />
            {/** -------------------------------- Caudal de Gas Salida HESP --------------------------------------- */}
            <Chart.Line
              name="Caudal de Gas Salida HESP"
              data={caudalGasSHESP.value}
              yAxis={0}
            />
            {/** -------------------------------- %N2 Salida HESP --------------------------------------- */}
            <Chart.Line
              name="%N2 Salida HESP"
              data={porcentajeN2SHESP.value}
              yAxis={1}
            />
            {/** -------------------------------- %O2 Salida HESP --------------------------------------- */}
            <Chart.Line
              name="%O2 Salida HESP"
              data={porcentaje02SHESP.value}
              yAxis={1}
            />
            {/** -------------------------------- %H2O Salida HESP --------------------------------------- */}
            <Chart.Line
              name="%H2O Salida HESP"
              data={porcentajeH20SHESP.value}
              yAxis={1}
            />
            {/** -------------------------------- %S2 Salida HESP --------------------------------------- */}
            <Chart.Line
              name="%S2 Salida HESP"
              data={porcentajeS2SHESP.value}
              yAxis={1}
            />
            {/** -------------------------------- %SO2 Salida HESP --------------------------------------- */}
            <Chart.Line
              name="%SO2 Salida HESP"
              data={porcentajeS02SHESP.value}
              yAxis={1}
            />
            {/** -------------------------------- %As2S3 Salida HESP --------------------------------------- */}
            <Chart.Line
              name="%As2S3 Salida HESP"
              data={porcentajeAs2S3SHESP.value}
              yAxis={1}
            />
            {/** -------------------------------- %As4O6 Salida HESP --------------------------------------- */}
            <Chart.Line
              name="%As4O6 Salida HESP"
              data={porcentajeAs4O6SHESP.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={flujosSolidosSHESP.fecha} />

            <Chart.YAxis
              labelSuffix=" Nm3/h"
              title="Caudal de Gases, Nm3/h"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={80000}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
              max={80}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
